import { type RightSidebarContextMenuCallbackProps } from './contextMenuStructure.types';

export const createRightSidebarContextMenuCallbackProps = (props: RightSidebarContextMenuCallbackProps): RightSidebarContextMenuCallbackProps => ({
  ...props,
});
